var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 4.5V13.125C7.375 14.7825 6.0325 16.125 4.375 16.125C2.7175 16.125 1.375 14.7825 1.375 13.125V3.75C1.375 2.715 2.215 1.875 3.25 1.875C4.285 1.875 5.125 2.715 5.125 3.75V11.625C5.125 12.0375 4.7875 12.375 4.375 12.375C3.9625 12.375 3.625 12.0375 3.625 11.625V4.5H2.5V11.625C2.5 12.66 3.34 13.5 4.375 13.5C5.41 13.5 6.25 12.66 6.25 11.625V3.75C6.25 2.0925 4.9075 0.75 3.25 0.75C1.5925 0.75 0.25 2.0925 0.25 3.75V13.125C0.25 15.405 2.095 17.25 4.375 17.25C6.655 17.25 8.5 15.405 8.5 13.125V4.5H7.375Z",
    fill: "#086EA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.29c11fe24dcfeba6260f77896dfbd5a0.svg";
export { ForwardRef as ReactComponent };